import { KnownQueryKey as e } from "./index3.js";
import { createRegionCodeProvider as n, createCountryCodeProvider as a } from "@ado/location-library";
import { getCookieByName as d } from "@ado/cookie-library";
class u {
  provideParameter(r) {
    switch (r) {
      case e.CountryCode:
        return a().provideCountryCode();
      case e.Host:
        return window.location.hostname;
      case e.Brand:
        return d("brand");
      case e.RegionCode:
        return n().provideRegionCode();
    }
  }
  provideParameters(...r) {
    const o = {
      [e.Brand]: void 0,
      [e.CountryCode]: void 0,
      [e.RegionCode]: void 0,
      [e.Host]: void 0
    };
    for (const t of r)
      o[t] = this.provideParameter(t);
    return o;
  }
}
export {
  u as DefaultKnownQueryParametersProvider
};
//# sourceMappingURL=index2.js.map
